import React from "react";

const benefits = [
  {
    icon: "/images/icons/icon-1.svg",
    title: "Best Price Guarantee",
    text: "Affordable Mumbai Airport Cab fares with no hidden charges. Get the best value for your ride.",
  },
  {
    icon: "/images/icons/icon-2.svg",
    title: "Easy & Quick Booking",
    text: "Book your Mumbai airport taxi in seconds with instant confirmation and hassle-free experience.",
  },
  {
    icon: "/images/icons/icon-3.svg",
    title: "Experienced Drivers",
    text: "Professional and verified drivers ensure safe and comfortable airport transfers in Mumbai.",
  },
];

const BenefitsSection = () => {
  return (
    <section className="benefits--layout1  position-relative">

      {/* Background side  */}
      {/* <div
        className="img1"
        style={{
          background: "url('/images/why.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
        }}
      ></div> */}

      {/* Decorative element */}
      <div className="benefits-element1"></div>

      <div className="container">
        <div className="row justify-content-end">
          <div className="col-lg-6">
             <div className="title-area">
              <span className="sec-subtitle">
                Mumbai Airport Cab Benefits
              </span>

              {/* <h2 className="sec-title h1">
                Why Choose Our Airport Taxi Service?
              </h2> */}

              <p className="sec-text pe-xl-5 text-dark">
                We provide safe, reliable, and affordable Mumbai Airport Cab
                services 24/7 with professional drivers and clean vehicles.
              </p>
            </div>

            <img className="" src="/images/why.png"/>
          </div>
          <div className="col-lg-6 mb-30">

            {/* TITLE */}
             <div className="title-area">
              {/* <span className="sec-subtitle">
                Mumbai Airport Cab Benefits
              </span> */}

              <h2 className="sec-title h1">
                Why Choose Our Airport Taxi Service?
              </h2>

           {/*   <p className="sec-text pe-xl-5">
                We provide safe, reliable, and affordable Mumbai Airport Cab
                services 24/7 with professional drivers and clean vehicles.
              </p>*/}
            </div> 

            {/* BENEFITS LIST */}
            {benefits.map((item, index) => (
              <div className="item d-flex mb-4" key={index}>
                
                {/* ICON */}
                <div className="item__icon me-3">
                  <img
                    src={item.icon}
                    alt={item.title}
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>

                {/* CONTENT */}
                <div className="item__content">
                  <h3 className="item__title h4">
                    {item.title}
                  </h3>

                  <p className="item__text">
                    {item.text}
                  </p>
                </div>

              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;